<template>
  <div class="settings mt-5">
    <b-container>
     <b-row>
       <b-col md="12 text-center">
         <h5>{{ titleInfo.title }} @{{ titleInfo.room }}</h5>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card title="Their website" v-if="false" class="mb-4 bs">
           <b-card-text>
             {{ ctrl.url }}
           </b-card-text>
         </b-card>
       </b-col>
     </b-row>

     <b-row v-if="role_is_mod">
       <b-col md="12">
         <b-card title="" v-if="!role_is_owner" class="mb-4 bs">
           <b-card-text style="color:red">
              You are a moderator for this room. Below is what other users will see.
           </b-card-text>
         </b-card>
         <b-card title="" v-if="role_is_owner" class="mb-4 bs">
           <b-card-text style="color:red">
              You are a the owner of this room.  Below is what other users will see.
           </b-card-text>
         </b-card>
       </b-col>
     </b-row>

     <b-row>
       <b-col md="12">
         <b-card title="Available Webinars" class="mb-4 bs">
           <b-card-text>
             <div class="mb-3">
               <b-table
                 striped
                 show-empty
                 stacked="md"
                 :fields="roomWebinarFields"
                 :items="roomWebinars"
                 small
               >
               <template v-slot:cell(isreg)="data">
                 <b-button v-if="!data.item.isreg && !data.item.isfull && !data.item.isold" size="sm"
                    @click="do_self_regmeeting(data.item)" variant="secondary">
                    REGISTER
                 </b-button>
                 <b-button v-if="!data.item.isreg && !data.item.isfull && data.item.isold" size="sm"
                    disabled variant="secondary">
                    FINISHED
                 </b-button>
                 <b-button v-if="!data.item.isreg && data.item.isfull" size="sm"
                    disabled variant="secondary">
                    FULL
                 </b-button>
                 <b-button v-if="data.item.isreg" size="sm"
                    disabled variant="warning">
                    REGISTERED
                 </b-button>
               </template>
               <template v-slot:cell(name)="data"> 
                 {{ data.value }}
               </template>
               <template v-slot:cell(start_ep)="data">
                 {{ getMeetingStartDateTime(data.item) }}
               </template>
               <template v-slot:cell(end_ep)="data">
                 {{ getMeetingEndDateTime(data.item) }}
               </template>
               <template v-slot:cell(geo)="data">
                 <i v-if="data.item.geo && data.item.geo.ct" class="typcn typcn-lock-closed" style="color:red;font-size:120%"></i>
               </template>
               <template v-slot:row-details="row">
                 <div style="padding: 0 0 2px 5px">
                   <b-row class="mb-0" v-show="row.item.descr">
                    <b-col sm="1" class="text-sm-right"></b-col>
                    <b-col>{{ row.item.descr }}</b-col>
                   </b-row>
                   <b-row class="mb-0" v-show="row.item.url">
                     <b-col sm="1" class="text-sm-right"></b-col>
                     <b-col><b-link :href=row.item.url>Link with more details</b-link></b-col>
                   </b-row>
                 </div>
               </template>
               </b-table>
             </div>
           </b-card-text>
        </b-card>
        <b-card title="Invitations and Registrations" class="mb-4 bs">
           <b-card-text>
             <div class="mb-3">
               <b-table
                 striped
                 hover
                 show-empty
                 stacked="md"
                 :fields="meetingsRoomFieldsInv"
                 :items="meetingsRoom"
                 small
               >
               <template v-slot:cell(name)="data"> 
                 {{ data.value }}
               </template>
               <template v-slot:cell(start_ep)="data">
                 {{ getMeetingStartDateTime(data.item) }}
               </template>
               <template v-slot:cell(end_ep)="data">
                 {{ getMeetingEndDateTime(data.item) }}
               </template>
               </b-table>
             </div>
           </b-card-text>
        </b-card>
       </b-col>
     </b-row>

    </b-container>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import DatePicker from "vue2-datepicker";
import vx_api from "../vuemix";
import store from "../store";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { format, getUnixTime } from 'date-fns';

export default {
  name: "settings",
  mounted() {
    let vue = this;
    vue.setup_room(vue, window.vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid);
  },

  data() {
    return {
      titleInfo: { title: "", room: "()" },
      titleNickName: "()",
      role_is_mod: false,
      role_is_notmod: false,
      role_is_owner: false,
      meetingsRoom: [],
      meetingsRoomFieldsInv: [
          { key: "name", label: "Name" },
          { key: "start_ep", label: "Start" },
          { key: "end_ep", label: "End" },
      ],
      roomWebinars: [],
      roomWebinarFields: [
          { key: "isreg", label: ""},
          { key: "name", label: "Name" },
          { key: "start_ep", label: "Start" },
          { key: "end_ep", label: "End" },
          { key: "geo", label: "" },
      ],
    }  
  },

  methods: {
    setup_room: function(vue, vx, room_acc, room_name) {
      //console.log(room_acc+":"+room_name);
      vue.titleInfo.title = "";
      vue.titleInfo.room = "()";
      window.vx_set_room(vx, room_acc, room_name);
      if (vx.room.name) {
        vue.titleInfo.room = vx.room.name;
        vue.titleInfo.title = "";
        window.wss_open(vx, {
          acc: vx.room.acc,
          room: vx.room.name,
          uid: vx.user.id,
          dname: vx.user.dname,
          cred: vx.user.creds["me"],
          routes_id: "sched",
          routes: {
            auth_me: function(msg) {
              if (msg.data == "denied") {
                 vue.$parent.signUserOut("", "You have been signed out", "warning");
                 return;
              }
              if (window.is_my_room(window.vx)) {
                window.wss_send(vx, "auth_room", {
                  cred: vx.user.creds["myroom"]
                });
              } else {
                window.wss_send(vx, "auth_room", {});
              }
            },
            auth_room: vue.wss_auth_room,
            list_user: vue.wss_list_user,
            get_meetings: vue.wss_get_meetings,
            get_regmeetings: vue.wss_get_regmeetings,
            regmeeting: vue.wss_regmeeting,
          }
        });
      }
    },
    wss_auth_room: function(msg) {
      if (msg.data != "ok") {
        return;
      }
      window.wss_send(window.vx, "list_user", {});
      this.get_all_meetings();
    },
    wss_list_user: function(msg) {
      let vue = this;
      if (msg.data == "denied") {
        vue.role_is_notmod = true;
        vue.role_is_mod = false;
        vue.role_is_owner = false;
        return;
      }
      if (msg.data.uid == vx.user.id) {
        let r = msg.data.roles;
        vue.role_is_notmod = true;
        vue.role_is_mod = false;
        vue.role_is_owner = false;
        if (r.is_mod) {
           vue.role_is_mod = true;
        }
        if (r.is_owner) {
           vue.role_is_owner = true;
           vue.role_is_mod = true;
        }
        if (vue.role_is_mod || vue.role_is_owner) {
           vue.role_is_notmod = false;
        }
      }
    },
    wss_get_meetings: function(msg) {
      if (msg.data == "denied") {
         return;
      }
      let vue = this;
      let hash = {};
      let now = (Date.now() / 1000) - 1;
      msg.data.forEach(function(u) {
         let unique_meeting = u.name+":"+u.start_ep;
         hash[unique_meeting] = hash[unique_meeting] || {};
         
         let meeting = hash[unique_meeting];
         meeting.name = u.name;
         meeting.start_ep = u.start_ep;
         meeting.end_ep = u.end_ep;
         meeting.attendees = meeting.attendees || [];
         if (u.start_ep <= now) {
            if (u.end_ep <= now) {
              meeting._rowVariant = "danger";
            } else {
              meeting._rowVariant = "success";
            }
         }

         if (u.em == "_anchor_") {
           meeting.code = u.uid;
           meeting.name = u.name;
           meeting.canreg = u.canreg || 0;
           if (u.canreg && u.canreg > 0) {
             meeting.iswebinar = "true";
           } else {
             meeting.iswebinar = "false";
           }
           meeting.geo = {};
           if (u.geo) {
             meeting.geo.ct = u.geo.ct;
           }
           meeting.url = u.url;
           meeting.descr = u.descr;
         } else {
           let att = {};
           att.uid = u.uid;
           att.em = u.em;
           att.can_view = u.can_view || false;
           att.can_join = u.can_join || false;
           if (!att.uid) {
             att._rowVariant = "warning";
           }
           meeting.attendees.push(att);
         }
      });
      
      let list = [];
      Object.keys(hash).forEach(function(m) {
        let meeting = hash[m];
        if (vue.selectedMeeting && vue.selectedMeeting.name) {
           /* Need to refresh any selected meeting */
           if (vue.sameMeeting(meeting,vue.selectedMeeting)) {
              vue.selectedMeeting = meeting;
           }
        }
        list.push(meeting);
      });
      list = list.sort(function(a,b) {return a.start_ep - b.start_ep;});
      vue.meetingsRoom = list;
      
      /* Follow with get "webinars" if not own room */
      window.wss_send(window.vx, "get_regmeetings", {for_tm:"all"});
    },
    wss_get_regmeetings: function(msg) {
      if (msg.data == "denied") {
         return;
      }
      let vue = this;
      let list = [];
      let now = Date.now()/1000;
      msg.data.forEach(function(u) {
         let meeting = {};
         meeting.name = u.name;
         meeting.start_ep = u.start_ep;
         meeting.end_ep = u.end_ep;
         meeting.code = u.uid;
         meeting.isreg = false;
         meeting.regcnt = u.regcnt;
         meeting.canreg = u.canreg;
         meeting.isfull = (meeting.regcnt >= meeting.canreg);
         meeting.isold = (meeting.end_ep <= now);
         meeting.ison = !meeting.isold && (meeting.start_ep <= now);
         if (u.descr) { meeting.descr = u.descr; meeting._showDetails = true; }
         if (u.url) { meeting.url = u.url; meeting._showDetails = true; }
         meeting.geo = {};
         if (u.geo) {
           meeting.geo.ct = u.geo.ct;
         }
         /* For other's rooms this is only your invitations/registrations */
         vue.meetingsRoom.forEach(function(m) {
           if (vue.sameMeeting(meeting,m)) {
              meeting.isreg = true;
           }
         });
         list.push(meeting);
      });
      list = list.sort(function(a,b) {return a.start_ep - b.start_ep;});
      vue.roomWebinars = list;
    },
    wss_regmeeting: function(msg) {
      if (msg.data == "denied" || msg.data == "error") {
         return;
      }
      let vue = this;
      vue.roomWebinars.forEach(function(m) {
        if (m.code == msg.data.code) {
          m.isreg = msg.data.isreg;
        }
      });
    },
    get_all_meetings: function() {
      window.wss_send(window.vx, "get_meetings", {tgt_em:"self",for_tm:"all"});
    },
    getMeetingStartDateTime: function(m) {
      if (!m || !m.start_ep) { return "?"; }
      var st = new Date(m.start_ep * 1000);
      var now = new Date();
      if (st.getYear() == now.getYear()) {
         return format(st,'MM/dd E h:mma')
      } else {
         return format(st,'yyyy MM/dd E h:mma')
      }
    },
    getMeetingEndDateTime: function(m) {
      if (!m || !m.end_ep) { return "?"; }
      var et = new Date(m.end_ep * 1000);
      var now = new Date();
      if ((et - now) < 24*3600*1000) {
        if (et.getDay() == now.getDay()) {
          /* Same day, different hour */
          return format(et,'h:mma')
        } else {
          /* Within 24 hours but different days */
          return format(et,'E h:mma')
        }
      } else if (et.getYear() == now.getYear()) {
         /* Same year */
         return format(et,'MM/dd E h:mma')
      } else {
         return format(et,'yyyy MM/dd E h:mma')
      }
    },
    sameMeeting: function(m1, m2) {
      if (m1.name == m2.name && m1.start_ep == m2.start_ep) {
         return true;
      }
      return false;
    },
    do_self_regmeeting(meeting) {
      let vue = this;
      if (vue.role_is_mod) {
         vue.$parent.notification = { alertCountDown: 5,
           alertVariant: "warning",
           alertMessage: "You are an owner or moderator thus do not need to register."
         };
         return;
      }
      if (meeting.geo) {
        if (meeting.geo.ct) {
           if (!vue.$parent.currentUser.loc.ct) {
             vue.$parent.notification = { alertCountDown: 5,
               alertVariant: "warning",
               alertMessage: "This meeting is geo-locked and your location is not set. Please set your location in the account settings below."
             };
             vue.$parent.goAccount();
             return;
           }
           if (vue.$parent.currentUser.loc.ct != meeting.geo.ct) {
             vue.$parent.notification = { alertCountDown: 3,
               alertVariant: "warning",
               alertMessage: "This meeting is geo-locked and you are outside the target region."
             };
             return;
           }
        }
      }
      let up = { slots: [] };
      up.slots[0] = {};
      up.slots[0].start_ep = meeting.start_ep;
      up.slots[0].uid = meeting.code;
      up.slots[0].em = vue.$parent.currentUser.email;
      /* This adds user (or users) to the meeting records */
      window.wss_send(window.vx, "regmeeting", up);      
    },
  },
};
</script>


<style lang="scss" scoped>
.container {
  max-width: 760px;
}
</style>
